import styled from '@emotion/styled';

const Button = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
`;

const Container = styled.div`
    height: 100%;
    background: white;
`

const ButtonMinimize = styled(Button)`
  position: absolute;
  height: 100%;
  padding-left: 1.5em;
  padding-right: 1.5em;
  top: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
`;

export { Button, SrOnly, Container, ButtonMinimize };
